import { Box, PulseAnimation, SkeletonCircle } from '@wix/design-system';
import { HintSmall, LockLockedSmall, StatusAlertFilledSmall, TimeSmall } from '@wix/wix-ui-icons-common';
import React, { useCallback, useEffect, useState } from 'react';
import { RuleListStatus } from '../../types';
import { dataHooks } from '../../utils/datahooks';
import { usePreviousState } from '../../utils/use-previous-state';
import { CompletedTaskIcon } from './completed-task-icon';
const FailedIcon = () => {
  return /*#__PURE__*/React.createElement(Box, {
    color: "R10",
    dataHook: dataHooks.rulesListPrefixIconFailed
  }, /*#__PURE__*/React.createElement(StatusAlertFilledSmall, null));
};
const LoadingIcon = () => {
  return /*#__PURE__*/React.createElement(Box, {
    dataHook: dataHooks.rulesListPrefixIconLoading,
    padding: "2px"
  }, /*#__PURE__*/React.createElement(SkeletonCircle, {
    diameter: "14px"
  }));
};
const DisabledIcon = () => {
  return /*#__PURE__*/React.createElement(Box, {
    dataHook: dataHooks.rulesListPrefixIconLoading
  }, /*#__PURE__*/React.createElement(LockLockedSmall, null));
};
const RecommendationIcon = () => {
  return /*#__PURE__*/React.createElement(Box, {
    color: "B10",
    dataHook: dataHooks.rulesListPrefixIconRecommendation
  }, /*#__PURE__*/React.createElement(HintSmall, {
    size: "18px"
  }));
};
const PendingIcon = () => {
  return /*#__PURE__*/React.createElement(Box, {
    color: "Y20",
    dataHook: dataHooks.rulesListPrefixIconPending
  }, /*#__PURE__*/React.createElement(TimeSmall, {
    size: "18px"
  }));
};
export const StatusIcon = _ref => {
  let {
    status,
    onStatusChange
  } = _ref;
  const [isPulseActive, setIsPulseActive] = useState(false);
  const prevStatus = usePreviousState(status);
  useEffect(() => {
    if (prevStatus !== undefined && prevStatus !== status) {
      if (prevStatus === RuleListStatus.failed && status === RuleListStatus.passed) {
        setIsPulseActive(true);
      }
      onStatusChange == null || onStatusChange();
    }
  }, [prevStatus, setIsPulseActive, status, onStatusChange]);
  const PassedIcon = useCallback(() => {
    return /*#__PURE__*/React.createElement(Box, {
      padding: "2px"
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        position: 'relative',
        zIndex: 2
      }
    }, /*#__PURE__*/React.createElement(PulseAnimation, {
      active: isPulseActive,
      borderRadius: "50%",
      color: "G10",
      delay: "300ms",
      loop: false,
      onEnd: () => setIsPulseActive(false)
    }, /*#__PURE__*/React.createElement(Box, {
      dataHook: dataHooks.rulesListPrefixIconComplete
    }, /*#__PURE__*/React.createElement(CompletedTaskIcon, null)))));
  }, [isPulseActive]);
  const getStatusIcon = useCallback(() => {
    switch (status) {
      case RuleListStatus.passed:
        return /*#__PURE__*/React.createElement(PassedIcon, null);
      case RuleListStatus.failed:
        return /*#__PURE__*/React.createElement(FailedIcon, null);
      case RuleListStatus.error:
        // TODO: add an error icon if needed
        return /*#__PURE__*/React.createElement(FailedIcon, null);
      case RuleListStatus.disabled:
        return /*#__PURE__*/React.createElement(DisabledIcon, null);
      case RuleListStatus.recommendation:
        return /*#__PURE__*/React.createElement(RecommendationIcon, null);
      case RuleListStatus.loading:
        return /*#__PURE__*/React.createElement(LoadingIcon, null);
      case RuleListStatus.pending:
        return /*#__PURE__*/React.createElement(PendingIcon, null);
      default:
        return null;
    }
  }, [PassedIcon, status]);
  return /*#__PURE__*/React.createElement(Box, null, getStatusIcon());
};
//# sourceMappingURL=status-icon.js.map